import('./bootloader').then(async ({ mount }) => {
  const element = document.querySelector('#bfcm');
  if (!element) return;
  try {
    const dispose = await mount({ $element: element, standAlone: true });
    // A page kept in the back/forward cache must stay alive so that a restore finds a working page.
    window.addEventListener('pagehide', event => { if (!event.persisted) void dispose(); });
  } catch (error) {
    console.error('Peak Live could not start.', error);
    element.textContent = 'The network could not load. Please reload or try again later.';
    element.setAttribute('role', 'alert');
    element.dataset.revealed = 'true';
  }
}).catch(error => {
  console.error('Peak Live could not load its application module.', error);
  const element = document.querySelector('#bfcm');
  if (element) {
    element.textContent = 'The network could not load. Please reload or try again later.';
    element.setAttribute('role', 'alert');
    element.dataset.revealed = 'true';
  }
});
